import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  billingTermsRow: {
    paddingTop: theme.spacing(1.5),
  },
}))
